import Cookies from 'js-cookie';

export function parseRupees(value) {
  if (value === undefined || value === null || value === '') return 0;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? Math.trunc(n) : 0;
}

export function allocatedSum(subtasks, parentId = null) {
  return (subtasks || []).reduce((sum, st) => {
    const pid = st.parent_subtask_id || null;
    if (String(pid || '') !== String(parentId || '')) return sum;
    return sum + parseRupees(st.budget);
  }, 0);
}

export function unallocated(budget, subtasks, parentId = null) {
  return parseRupees(budget) - allocatedSum(subtasks, parentId);
}

export function allocationExceedsBudget(budget, subtasks, parentId = null) {
  const cap = parseRupees(budget);
  if (!cap) return false;
  return allocatedSum(subtasks, parentId) > cap;
}

export function formatRupees(value) {
  if (value === undefined || value === null || value === '') return '---';
  const n = Number(value);
  if (!Number.isFinite(n)) return '---';
  return `₹${n.toLocaleString()}`;
}

export const ALLOCATION_EXCEEDED_MESSAGE =
  'Child allocations cannot exceed the parent budget';

export const OVER_ALLOCATION_OWNER_MESSAGE =
  'Spend that exceeds remaining allocation requires the task owner to approve';

export const SPEND_OWNER_MESSAGE = 'Only the task owner can approve spend';
export const SPEND_APPROVAL_TYPE = 'Spend Approval';

export const SPEND_EXTERNAL_MESSAGE =
  'Vendors and service providers cannot approve spend';

export function lineExceedsAllocation(subtask, amount) {
  const budget = subtask?.budget;
  if (budget == null || budget === '') return false;
  return Number(subtask?.actual || 0) + Number(amount || 0) > Number(budget);
}

export function isExternalSession() {
  const role = String(Cookies.get('userRole') || '').toLowerCase();
  return role === 'vendor' || role === 'service-provider' || role === 'service_provider';
}

export function evaluateSpendApprove({ isOwner, isExternal }) {
  if (isExternal) {
    return { allowed: false, message: SPEND_EXTERNAL_MESSAGE };
  }
  if (!isOwner) {
    return { allowed: false, message: SPEND_OWNER_MESSAGE };
  }
  return { allowed: true };
}
